import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StarRatingComponent),
      multi: true
    }
  ]
})

export class StarRatingComponent implements OnInit, ControlValueAccessor {
  @Input() rating: number = 0;
  @Output() ratingChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() disabled: boolean = false;
  stars: boolean[] = Array(5).fill(false);
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() { }

  ngOnInit() {
    this.updateStars();
  }

  private updateStars(): void {
    this.stars = this.stars.map((_, i) => i < this.rating);
  }

  public rate(rating: number): void {
    if (!this.disabled) {
      this.rating = rating;
      this.updateStars();
      this.onChange(this.rating);
      this.ratingChange.emit(this.rating);
    }
  }

  writeValue(rating: number): void {
    this.rating = rating;
    this.updateStars();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(disabled: boolean): void {
    this.disabled = disabled;
  }

  onTouchedHandler() {
    this.onTouched();
  }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/star-rating/star-rating.component.ts